export async function captureWholeAppScreenshot(): Promise<string | null> {
    if (!navigator.mediaDevices?.getDisplayMedia) return null;

    const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { selfBrowserSurface: "include" } as MediaTrackConstraints,
        audio: false,
        // @ts-expect-error: preferCurrentTab is a Chrome-specific non-standard option
        preferCurrentTab: true,
    });

    try {
        const video = document.createElement("video");
        video.muted = true;
        video.srcObject = stream;

        await new Promise<void>((resolve) => {
            video.onloadedmetadata = () => resolve();
        });
        await video.play();

        // Let the first frame render before capturing
        await new Promise<void>((resolve) => setTimeout(resolve, 100));

        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        if (!ctx) return null;

        ctx.drawImage(video, 0, 0);
        return canvas.toDataURL("image/png");
    } finally {
        stream.getTracks().forEach((t) => t.stop());
    }
}
